import { PanelDrawer } from "@theme/panel-drawer";

/**
 * Shipping panel (See How It Arrives). Opens from any `#shipping-panel` link
 * on the page or `on:click="#shipping-panel/open"`; everything else comes
 * from PanelDrawer.
 *
 * @extends PanelDrawer
 */
class ShippingPanel extends PanelDrawer {}

if (!customElements.get("shipping-panel")) {
  customElements.define("shipping-panel", ShippingPanel);
}
